@if (isLoading) {
  <ziro-loading-block></ziro-loading-block>
}
@if (!isLoading) {
  @if (!isTargetUserSelected) {
    <ziro-reassign-user-search
      [reassignType]="ReassignTypes.USER_TO_USER"
      [serverId]="serverId"
    ></ziro-reassign-user-search>
  }
  @if (isTargetUserSelected) {
    <ziro-reassign-user-execute
      [reassignType]="ReassignTypes.USER_TO_USER"
      [isVoicemailPresentOnLineOne]="isVoicemailPresentOnLineOne"
      [serverId]="serverId"
      [siteId]="siteId"
      (reassignClicked)="onReassignClicked($event)"
    ></ziro-reassign-user-execute>
  }
}
